/* eslint-disable react/no-unescaped-entities */
import * as React from 'react';
import {Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle} from '@mui/material';

export default function Alert_Dialog() {
  const [open, setOpen] = React.useState(false);
  const handleClose = () => {
    setOpen(false);
  };
  return (
    <div>
      <Dialog aria-describedby="alert-dialog-slide-description" open={open}>
        <DialogTitle>Warning: UnitOp Deletion</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            Are you sure?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button className='' onClick={handleClose}>Yes</Button>
          <Button className='' onClick={handleClose}>No</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
